// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"695":"f112f3d3b528c99a","9633":"d5feb23a95b51093"}[chunkId] + ".css";
};